import { useState, useEffect } from 'react';
import { getModelAssetsAvailable } from 'services/analytics';
import { useDispatch } from 'react-redux';
import { formatAssetDisplayName } from 'helpers/utils';
import { showError } from '../../../../../redux/common/actions';
import { SHOW_ALL_OPTION } from '../../constants';

export const useAssets = (modelId, showAll = true) => {
  const dispatch = useDispatch();
  const [assets, setAssets] = useState([]);

  useEffect(() => {
    const loadAssets = async () => {
      if (!modelId) {
        setAssets([]);
        return;
      }
      
      try {
        const response = await getModelAssetsAvailable({ modelId });
        if (response?.status) {
          const fetchedAssets = response.data || [];
          const withName = fetchedAssets.map(a => ({
            id: a.siteAssetRegisterID || a.id,
            assetNumber: a.assetNumber || a.name,
            reference: a.assetReferenceName || '',
            name: formatAssetDisplayName(a, true)
          }));

          const updatedAssets = (showAll && withName.length > 0)
            ? [SHOW_ALL_OPTION, ...withName]
            : withName;
          setAssets(updatedAssets);
        }
      } catch (error) {
        dispatch(showError('Failed to load assets'));
        setAssets([]); // Reset on error
      }
    };
    loadAssets();
  }, [modelId, showAll]);

  return assets;
}; 
